var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArgentina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M24-.003H0V5.33h24V-.003zm0 10.673H0v5.332h24V10.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M13.912 8l-.78.367.413.758-.848-.165-.105.862-.592-.63-.593.63-.105-.862-.847.165.412-.758-.78-.367.78-.368-.412-.757.847.165.105-.863.593.63.592-.63.105.863.848-.165-.413.757.78.368z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgentina);
export default __webpack_public_path__ + "static/media/Argentina.e7d065cabf48b5559957d50e4f0d4c23.svg";
export { ForwardRef as ReactComponent };